export const statusLabels: { [key in PrismaMonitorStatus]: string } = {
    SUCCESS: 'Success',
    WARNING: 'Warning',
    INSUFFICIENT_DATA: 'Incomplete',
    FAILURE: 'Failure',
    DONE: 'Done',
    FUTURE: 'Future',
};
